import { isInsideOverlay } from "@salestrak/ui";
import type {
  FieldSurface,
  FieldControlSize,
} from "#app/lib/custom-field-utils";

// "table" strips the control down to a borderless inline cell WITH NO INSET OF
// ITS OWN — the host cell pads both its rest and editing states
// (`EditableValueCell inset`, the drawer's `InlineEditingCell paddingX`), which
// is what keeps the text from shifting when editing starts.
// Every field surface but the default is a library control variant.
export function controlVariantFor(surface: FieldSurface): "outline" | "ghost" | "table" | undefined {
  return surface === "default" ? undefined : surface;
}

// The app's field-control scale ("xs"–"xl") clamps onto the narrower control
// scale, same as `toEntityTriggerSize` does for selectors.
export function toControlSize(
  size: FieldControlSize | undefined,
): "sm" | "default" | "lg" | undefined {
  switch (size) {
    case "xs":
    case "sm":
      return "sm";
    case "lg":
    case "xl":
      return "lg";
    case "default":
      return "default";
    default:
      return undefined;
  }
}

export function scheduleFieldDeactivate(
  fieldRoot: HTMLElement | null,
  onDeactivate?: () => void,
  allowPortalFocus: boolean | (() => boolean) = false,
) {
  if (!onDeactivate) return;

  requestAnimationFrame(() => {
    const activeElement = document.activeElement as HTMLElement | null;

    if (fieldRoot?.contains(activeElement)) {
      return;
    }

    const portalFocusAllowed =
      typeof allowPortalFocus === "function"
        ? allowPortalFocus()
        : allowPortalFocus;

    if (portalFocusAllowed && isInsideOverlay(activeElement)) {
      return;
    }

    onDeactivate();
  });
}
